import React from 'react';
import { createIconSet } from 'react-native-vector-icons';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const WhatsAppTemplateIcon = ({ color = '#000', size = 24, ...props }) => {
  return (
    <View {...props}>
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
        <Path
          d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM16 12H8V10H16V12ZM14 16H8V14H14V16ZM10 18H8V16H10V18Z"
          fill={color}
        />
      </Svg>
    </View>
  );
};

export default WhatsAppTemplateIcon;
